import { Stack, Box, Typography } from "@mui/material";
import {
  LocalOffer as TagIcon,
  Check as CheckIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import "../../styles/BulkTagMappingLandingPage.css";

/**
 * Summary statistics pills component displaying total, mapped, and unmapped tag counts.
 *
 * @param {Object} props - Component props
 * @param {Object} props.summaryStats - Statistics object
 * @param {number} props.summaryStats.totalTags - Total number of tags
 * @param {number} props.summaryStats.mappedTags - Number of mapped tags
 * @param {number} props.summaryStats.unmappedTags - Number of unmapped tags
 */
const BulkTagMappingSummaryStats = ({ summaryStats }) => {
  return (
    <Stack direction='row' spacing={2} sx={{ mb: 2, mt: 2 }}>
      <Box className='bulk-tag-mapping-summary-pill bulk-tag-mapping-summary-pill-total'>
        <TagIcon className='bulk-tag-mapping-summary-pill-icon' />
        <Typography
          variant='body2'
          className='bulk-tag-mapping-summary-pill-text'>
          {summaryStats.totalTags.toLocaleString()} Total Tags
        </Typography>
      </Box>
      <Box className='bulk-tag-mapping-summary-pill bulk-tag-mapping-summary-pill-mapped'>
        <CheckIcon className='bulk-tag-mapping-summary-pill-icon' />
        <Typography
          variant='body2'
          className='bulk-tag-mapping-summary-pill-text'>
          {summaryStats.mappedTags.toLocaleString()} Mapped
        </Typography>
      </Box>
      <Box className='bulk-tag-mapping-summary-pill bulk-tag-mapping-summary-pill-unmapped'>
        <CloseIcon className='bulk-tag-mapping-summary-pill-icon' />
        <Typography
          variant='body2'
          className='bulk-tag-mapping-summary-pill-text'>
          {summaryStats.unmappedTags.toLocaleString()} Unmapped
        </Typography>
      </Box>
    </Stack>
  );
};

export default BulkTagMappingSummaryStats;
